import { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { isLogedIn, userRole, userDetails } from "../../api";
import Loader from "../../components/Loader";

const getAuthRedirect = () => {
    const userDetail = userDetails();
    const role = userRole();
    if (!userDetail) return null;

    const status = userDetail?.onboard_status;
    if (role === 'Employee' || role === 'Client') {
        if (status === 'offer_sign') return { path: "/offer-letter" };
        if (status !== 'completed') {
            return {
                path: role === 'Employee'
                    ? "/employee-onboard-sections"
                    : "/client-gusto-onboard-sections",
            };
        }
    }
    if (userDetail?.dashbaord_url) return { url: userDetail.dashbaord_url };
    if (userDetail?.user_completion_status) return { path: "/dashboard" };
    return null;
};

const AuthCheck = ({ children }) => {
    const navigate = useNavigate();
    const isLoggedIn = isLogedIn();
    const redirect = isLoggedIn ? getAuthRedirect() : null;

    useEffect(() => {
        if (redirect?.path) {
            navigate(redirect.path);
        } else if (redirect?.url) {
            window.open(redirect.url, "_self");
        }
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    if (!redirect) {
        return children;
    }
    return <Loader />;
};

export default AuthCheck;
